import { UserTypeEnum } from '@sr-sdks/api-sdk-axios';
import { Card, CardContent, CardTitle } from '@sr/ui-library';
import { useEffect } from 'react';
import { useOutletContext } from 'react-router-dom';
import IfFeatureEnabledMSR3 from '../../../components/IfFeatureEnabledMSR3';
import InvitedTable from '../../../components/InvitedTable';
import RoleAccessTable from '../../../components/RoleAccessTable';
import TeammatesTable from '../../../components/TeammatesTable';
import { useActiveWorkspace } from '../../../hooks/useActiveWorkspace';
import { workspaceService } from '../../../reducers/workspaces/workspaceSlice';
import { useAppDispatch } from '../../../stateStore';
import { WorkspaceOutletContext } from '../../../types/workspaceTypes';

const SettingsCard = ({ children }: React.PropsWithChildren) => (
  <Card className="border-neutral-300 shadow-sm">
    <CardContent className="flex w-full flex-col p-4 sm:p-6">
      {children}
    </CardContent>
  </Card>
);

export const Teammates = (): JSX.Element => {
  const dispatch = useAppDispatch();
  const [activeWorkspace] = useActiveWorkspace();
  const { isInviteTeammateRequested, onInviteTeammateHandled } =
    useOutletContext<WorkspaceOutletContext>();

  // InvitedTable (legacy) still reads workspace data from Redux, not React Query.
  // Fetch it here because this settings page doesn't load it automatically.
  // TODO: Remove this when InvitedTable is migrated to React Query.
  useEffect(() => {
    if (!activeWorkspace?._id) return;

    dispatch(workspaceService.findOne(activeWorkspace._id));
  }, [dispatch, activeWorkspace?._id]);

  return (
    <div className="flex flex-col gap-8">
      <SettingsCard>
        <TeammatesTable
          filterElement={<CardTitle>Onboarded Teammates</CardTitle>}
          hasBottomNavigation={false}
          workspaceId={activeWorkspace?._id}
        />
      </SettingsCard>

      <SettingsCard>
        <InvitedTable
          filterElement={<CardTitle>Invited Teammates</CardTitle>}
          hasBottomNavigation={false}
          shouldOpenInviteModal={isInviteTeammateRequested}
          workspaceId={activeWorkspace?._id}
          onInviteModalOpened={onInviteTeammateHandled}
        />
      </SettingsCard>

      <IfFeatureEnabledMSR3 name="workspace.teammates.roleAccessTable">
        <SettingsCard>
          <RoleAccessTable
            filterElement={<CardTitle>Role Access Breakdown</CardTitle>}
            hideDescription
            roleType={UserTypeEnum.External}
          />
        </SettingsCard>
      </IfFeatureEnabledMSR3>
    </div>
  );
};
